// Lib
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { onlyUpdateForPropTypes } from '../../../node_module_clones/recompose';

// Util
import workspaceInitialisationMonitoringSingleton from '../../workspace/initialisation/workspaceInitialisationMonitoringSingleton';
import { getTranslatedChildrenDescription } from '../../utils/i18n/translationHelpers';
import { GroupTranslatorProvider, useGroupTranslator } from '../../components/i18n/GroupTranslationContext';

// Styles
import './ElementContentsTag.scss';

const ContainerElementChildCountContentBase = ({ children, childrenTypes, show, isBoardDuplicating, isBoard }) => {
    const groupTranslate = useGroupTranslator();

    useEffect(() => {
        if (show && isBoard) {
            workspaceInitialisationMonitoringSingleton.setBoardCountsInitialised(true);
        }
    }, [show]);

    const description = useMemo(
        () => getTranslatedChildrenDescription(childrenTypes, isBoardDuplicating, groupTranslate, false),
        [childrenTypes, isBoardDuplicating, groupTranslate],
    );

    return (
        <div className="ContainerElementChildCount ElementContentsTag">
            <span className={classNames('text', { show })}>{description}</span>
            {children}
        </div>
    );
};

ContainerElementChildCountContentBase.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    childrenTypes: PropTypes.object,
    show: PropTypes.bool,
    isBoardDuplicating: PropTypes.bool,
    isBoard: PropTypes.bool,
};

// Apply performance optimization to the inner component
const ContainerElementChildCountContent = onlyUpdateForPropTypes(ContainerElementChildCountContentBase);

const ContainerElementChildCount = (props) => {
    return (
        <GroupTranslatorProvider group="elements">
            <ContainerElementChildCountContent {...props} />
        </GroupTranslatorProvider>
    );
};

export default ContainerElementChildCount;
